import React from "react";
import { ButtonColor, ButtonSize, ButtonVariant } from "enums/Button";
import { IconType } from "enums/Icon";
import Button, { ButtonProps } from "../Button/Button";
import { PayIcon } from "./PaymentButton.styles";

// The look is not the caller's to change: a button that does not pay is a
// kit Button.
export type PaymentButtonProps = Omit<
  ButtonProps,
  "color" | "variant" | "size" | "leading" | "trailing"
>;

const payIcon = <PayIcon type={IconType.Money} />;

// The one button that pays: the payment mint, filled and large.
const PaymentButton: React.FC<PaymentButtonProps> = React.memo(
  (buttonProps) => (
    <Button
      color={ButtonColor.Secondary}
      variant={ButtonVariant.Filled}
      size={ButtonSize.Large}
      leading={payIcon}
      {...buttonProps}
    />
  ),
);

export default PaymentButton;
